import * as firebase from 'firebase/app'
import 'firebase/analytics'
import firebaseConfig from './firebaseConfig.json'

firebase.initializeApp(firebaseConfig)

firebase.analytics()

export default firebase.analytics
